import { produce } from 'immer';
import { getApolloClient } from '@frameio/graphql-client';
import { NOTIFICATIONS_LIST_FILTERS } from '../components/NotificationsListFilter/types';
import { PAGE_SIZE } from '../constants';
import { GetNotificationGroups } from '../gql';

export const markAllCachedNotificationGroupsAsRead = ({
  accountId,
  filter,
}: {
  accountId: string;
  filter: NOTIFICATIONS_LIST_FILTERS;
}) => {
  const client = getApolloClient();
  const unreadOnly =
    filter === NOTIFICATIONS_LIST_FILTERS.UNREAD ? { unreadOnly: true } : {};

  const existingQuery = client.cache.readQuery({
    query: GetNotificationGroups,
    variables: {
      accountId,
      page: {
        first: PAGE_SIZE,
      },
      ...unreadOnly,
    },
  });

  const newData = produce(existingQuery, (draft = {}) => {
    if (!draft || !draft.account) return;

    if (filter === NOTIFICATIONS_LIST_FILTERS.UNREAD) {
      draft.account.notificationGroups.nodes = [];
    } else {
      draft.account.notificationGroups.nodes =
        draft.account.notificationGroups.nodes.map((notification) => {
          return {
            ...notification,
            isRead: true,
          };
        });
    }

    draft.account.notificationGroups.hasUnreads = false;
  });

  /** Using `writeQuery` to update the Apollo cache with the updated read/unread
   * notifications. We don't use `cache.modify` as we can't target the
   * Notification fragment due to the various possible typename values.
   */
  return client.cache.writeQuery({
    query: GetNotificationGroups,
    variables: {
      accountId,
      page: {
        first: PAGE_SIZE,
      },
      ...unreadOnly,
    },
    data: newData,
  });
};
